module.exports = __webpack_public_path__ + "static/media/PlanExceededLogo.272a86cc.svg";